import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Config } from '@core/models/config.model';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private http = inject(HttpClient);

  private baseUrl: string = environment.apiUrl + '/config';

  public getConfig(): Observable<Config> {
    return this.http.get<Config>(`${this.baseUrl}`);
  }
}
